import { SIMULATION_CALCULATION_TYPE_OPTIONS } from '@/constants/simulation.const';
import { CalculateSimulationRequest } from '@/libs/fleet-api/services/simulation';
import { FormInstance } from 'antd';
import { Rule } from 'antd/es/form';

export const validatePaymentBreakdown = (
	form: FormInstance<CalculateSimulationRequest>,
	tenorInYear: number,
	calcType: SIMULATION_CALCULATION_TYPE_OPTIONS,
): Rule => ({
	async validator() {
		const allValues = form.getFieldsValue();
		const percentages = allValues.paymentBreakdownPercentages;

		// Check total percentage
		const total = percentages.reduce((sum, current) => sum + (current || 0), 0);
		if (total !== 100) {
			return Promise.reject(new Error('Total komposisi angsuran harus 100%'));
		}

		// Check for Step-Up rule if applicable
		if (calcType === SIMULATION_CALCULATION_TYPE_OPTIONS.STEP_UP) {
			for (let i = 0; i < tenorInYear - 1; i++) {
				const currentYearValue = percentages[i];
				const nextYearValue = percentages[i + 1];

				// Ensure both values are valid numbers before comparison
				if (
					currentYearValue !== undefined &&
					nextYearValue !== undefined &&
					currentYearValue >= nextYearValue
				) {
					return Promise.reject(
						new Error(`Tahun ${i + 1} harus lebih kecil dari Tahun ${i + 2}`),
					);
				}
			}
		} else if (calcType === SIMULATION_CALCULATION_TYPE_OPTIONS.STEP_DOWN) {
			for (let i = 0; i < tenorInYear - 1; i++) {
				const currentYearValue = percentages[i];
				const nextYearValue = percentages[i + 1];

				// Ensure both values are valid numbers before comparison
				if (
					currentYearValue !== undefined &&
					nextYearValue !== undefined &&
					currentYearValue <= nextYearValue
				) {
					return Promise.reject(
						new Error(`Tahun ${i + 1} harus lebih besar dari Tahun ${i + 2}`),
					);
				}
			}
		}

		return Promise.resolve();
	},
});
